


















import Vue from "vue";
import { Component, Ref } from "vue-property-decorator";
import DomainsTable from "@/components/app/admin/domains/domainsTable.vue";
@Component({
  components: {
    DomainsTable
  }
})
export default class AdminDomains extends Vue {
  @Ref()
  public readonly domainsTable!: DomainsTable;
  public async openCreateModal() {
    if (this.$userCan("create_oauth_client")) {
      await this.$store.dispatch("data/oauthClients/openManageDomainModal", {
        events: {
          "domain-saved": () =>
            this.domainsTable.getData({ ignoreStored: true })
        }
      });
    }
  }
}
